export default {
  getInstitutions() {
    return {
      data: {
        Institutions: {
          Institution: [
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '95',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'ADCB, UAE',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '96',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'Abu Dhabi Islamic Bank, UAE',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '148',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'Al Masraf Bank, UAE',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '246',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'Arab Bank, UAE',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '137',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'BLOM Bank France, UAE',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '108',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'Bank Of Baroda, UAE',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '150',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'Bank of Sharjah, UAE',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '149',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'Banque Misr, UAE',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '106',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'Citibank, UAE',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '116',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'Commercial Bank International, UAE',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '97',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'Commercial Bank Of Dubai, UAE',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '98',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'Dubai Islamic Bank, UAE',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '99',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'Emirates Islamic Bank, UAE',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '103',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'EmiratesNBD, UAE',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '515',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'First Abu Dhabi Bank, UAE',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '100',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'First Gulf Bank, UAE',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '554',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'HP State Co-Op Bank Ltd, India',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '107',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'HSBC, UAE',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '130',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'Habeeb Bank Limited, UAE',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '131',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'Habib Bank AG Zurich, UAE',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '119',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'Invest Bank, UAE',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '136',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'Janata Bank Ltd, UAE',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '101',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'Mashreq Bank, UAE',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '102',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'NBAD, UAE',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '555',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'Nanded Merchants Co-Op Bank Ltd, India',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '134',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'National Bank of Fujairah, UAE',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '138',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'National Bank of Umm Al Qaiwain, UAE',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '117',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'Noor Bank, UAE',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '93',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'RAKBANK, UAE',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '557',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'Rabo Bank, India',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '553',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'Raigad District Central Co-Op Bank Ltd, India',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '104',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'Sharjah Islamic Bank, UAE',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '94',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'Standard Chartered Bank, UAE',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '558',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'The Dahod Urban-Co-Op.Bank Ltd, India',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '565',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'The Surat Mercantile Co-Op. Bank Ltd, India',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '105',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'Union National Bank, UAE',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '133',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'United Arab Bank, UAE',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '132',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'United Bank Limited, UAE',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '564',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'Vyapari Sahakari Bank Maryadit, India',
              originalStatementAvailable: 'false',
            },
            {
              addressAvailable: 'false',
              form26AsAvailable: 'false',
              id: '544',
              institutionType: 'bank',
              itrVAvailable: 'false',
              name: 'Wardha Nagari Sahakari Adhikosh Bank Ltd, India',
              originalStatementAvailable: 'false',
            },
          ],
        },
      },
    };
  },
};
